/* @flow */

import { makeIDLink } from './utils';

export default makeIDLink({ pathname: '/projects' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/ProjectLink.js